import React from "react";

import { MuiThemeProvider, createTheme } from "@material-ui/core/styles";
import styled, { ThemeProvider } from "styled-components";
import { Provider } from "react-redux";

import AppTheme from "./styles";
import store from "./store";

import {
  DesignSystemThemeProvider,
  DesignSystemGlobalStyles,
} from "./design-system";

import Root from "./components/Root";
import ErrorBoundary from "./components/ErrorBoundary";
import TikTokCallback from "./components/screens/mediaStudio/connections/TikTokCallback";
import LinkedInCallback from "./components/screens/mediaStudio/connections/LinkedInCallback";
import MetaCallback from "./components/screens/mediaStudio/connections/MetaCallback";
import XCallback from "./components/screens/mediaStudio/connections/XCallback";
import YouTubeCallback from "./components/screens/mediaStudio/connections/YouTubeCallback";
import TikTokProductPage from "./components/screens/public/TikTokProductPage";

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.containerColor};
`;

const theme = createTheme({
  palette: {
    type: 'dark',
    primary: { main: '#ffffff' },
    secondary: { main: '#333333' },
    background: {
      paper: '#1a1a1a',
      default: '#111111',
    },
    text: {
      primary: '#ffffff',
      secondary: '#aaaaaa',
    },
  },
});

const App = () => {
  // Social OAuth redirects land on real paths (/auth/{tiktok,linkedin}/callback),
  // but the app runs on a HashRouter that would never route them. Intercept them
  // here, before redux/login gating, and finish the connection in a standalone
  // view.
  if (typeof window !== "undefined") {
    const path = window.location.pathname.replace(/\/$/, "") || "/";
    if (path === "/tiktok") {
      return (
        <DesignSystemThemeProvider forcedMode="dark">
          <DesignSystemGlobalStyles />
          <TikTokProductPage />
        </DesignSystemThemeProvider>
      );
    }
    if (path === "/auth/tiktok/callback") {
      return (
        <DesignSystemThemeProvider>
          <DesignSystemGlobalStyles />
          <TikTokCallback />
        </DesignSystemThemeProvider>
      );
    }
    if (path === "/auth/linkedin/callback") {
      return (
        <DesignSystemThemeProvider>
          <DesignSystemGlobalStyles />
          <LinkedInCallback />
        </DesignSystemThemeProvider>
      );
    }
    if (path === "/auth/meta/callback") {
      return (
        <DesignSystemThemeProvider>
          <DesignSystemGlobalStyles />
          <MetaCallback />
        </DesignSystemThemeProvider>
      );
    }
    if (path === "/auth/x/callback") {
      return (
        <DesignSystemThemeProvider>
          <DesignSystemGlobalStyles />
          <XCallback />
        </DesignSystemThemeProvider>
      );
    }
    if (path === "/auth/youtube/callback") {
      return (
        <DesignSystemThemeProvider>
          <DesignSystemGlobalStyles />
          <YouTubeCallback />
        </DesignSystemThemeProvider>
      );
    }
  }

  return (
    <DesignSystemThemeProvider>
      <DesignSystemGlobalStyles />
      <MuiThemeProvider theme={theme}>
        <ThemeProvider theme={AppTheme}>
          <Wrapper>
            <Provider store={store}>
              <ErrorBoundary>
                <Root />
              </ErrorBoundary>
            </Provider>
          </Wrapper>
        </ThemeProvider>
      </MuiThemeProvider>
    </DesignSystemThemeProvider>
  );
};
export default App;
